module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_f_leucistic.1ff3a066.png";